import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { IGridService } from '../models/igrid-service';
import { CompteGeneralDto } from '@lexi-clients/lexi';

@Injectable({
  providedIn: 'root'
})
export class CompteGeneralService implements IGridService<CompteGeneralDto> {
  baseUrl: string;

  constructor(
    private http: HttpClient, 
    envService: EnvironmentService
  ) {
    this.baseUrl = envService.environment.baseServiceUrl;
  }

  get(params: HttpParams): Observable<any> {
    return this.http.get<any>(`${this.baseUrl}/api/ComptesGeneraux/recherche-devexpress`, { params: params });
  }

  getById(compteGeneralCode: string): Observable<CompteGeneralDto> {
    // Implementation à compléter selon les besoins
    return null;
  }

  post(valeur: CompteGeneralDto): Observable<any> {
    // Implementation à compléter selon les besoins
    return null;
  }

  put(valeur: CompteGeneralDto): Observable<any> {
    // Implementation à compléter selon les besoins
    return null;
  }

  delete(valeur: CompteGeneralDto): Observable<any> {
    // Implementation à compléter selon les besoins
    return null;
  }
}
